module.exports = __webpack_public_path__ + "img/弹窗@2x.8a46be04.png";